import styled from 'styled-components';

export const Image = styled.img.attrs({
  src: props => props.src,
  alt: props => props.alt,
  width: props => props.width,
  height: props => props.height,
  margin: props => props.margin,
  borderradius: props => props.borderradius,
  opacity: props => props.opacity
})`
  width: ${props => props.width};
  height: ${props => props.height};
  margin: ${props => props.margin};
  border-radius: ${props => props.borderradius};
  opacity: ${props => props.opacity};
`;
